import React from "react";

const Team = () => {
  const horneliusPfp =
    "https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/hornelius.png";
  const sammyPfp =
    "https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/sealuminati_71.png";
  const richardPfp =
    "https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/richard_sealuminati.png";
  const cookiesPfp =
    "https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/cookies.png";

  const teamMembers = [
    {
      name: "hornelius",
      description: "co-founder | dev",
      image: horneliusPfp,
      xLink: "https://twitter.com/hornelius",
    },
    {
      name: "sammy",
      description: "co-founder | lead",
      image: sammyPfp,
      xLink: "https://twitter.com/Web3gamed",
    },
    {
      name: "cookies",
      description: "co-founder | artist",
      image: cookiesPfp,
      xLink: "https://twitter.com/cook_ees",
    },
    {
      name: "richard",
      description: "co-founder | artist | defi god",
      image: richardPfp,
      xLink: "https://twitter.com/richardnhsu",
    },
  ];

  return (
    <section
      id="team"
      className="w-full px-4 flex flex-col items-center font-imfellenglish mb-20 select-none"
    >
      <h2 className="text-4xl md:text-6xl font-bold text-white">
        meet the team
      </h2>

      {/*
        - grid-cols-2 => On mobile & small screens, 2 columns across for a 2x2 grid
        - md:grid-cols-4 => On medium screens (=768px), switch to 4 columns in one row
        - gap-8 => spacing between items
        - place-items-center => center them horizontally & vertically in their cells
      */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-screen-xl place-items-center">
        {teamMembers.map((member) => (
          <div
            key={member.name}
            className="
              p-4
              rounded-lg
              flex flex-col items-center
              shadow-lg
              hover:shadow-2xl
              transition-shadow
              duration-300
            "
          >
            {/* Clickable PFP linking to X (Twitter) */}
            <a
              href={member.xLink}
              target="_blank"
              rel="noopener noreferrer"
              className="mb-4"
            >
              <img
                src={member.image}
                alt={member.name}
                className="w-40 h-40 object-cover"
              />
            </a>

            <h3 className="text-2xl font-semibold text-primary mt-2 text-center">
              {member.name}
            </h3>
            {member.description && (
              <p className="text-lg text-white text-center mt-1">
                {member.description}
              </p>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Team;
